export type ProductAnimation = 'routing' | 'retail' | 'factory';

export interface ProductDef {
  slug: string;
  key: 'routing' | 'retail' | 'factory';
  animation: ProductAnimation;
}

export const PRODUCTS: ProductDef[] = [
  { slug: 'simpian-routing', key: 'routing', animation: 'routing' },
  { slug: 'bilingual-retail-last-mile', key: 'retail', animation: 'retail' },
  { slug: 'factory-ops', key: 'factory', animation: 'factory' },
];

export function productBySlug(slug: string | undefined): ProductDef | undefined {
  return PRODUCTS.find((product) => product.slug === slug);
}

export const SITE_URL = 'https://simpian.com';
export const CONTACT_EMAIL = 'info@simpian.com';
export const CONTACT_ADDRESS = '333 Wilson Ave, Toronto, Ontario, Canada';
export const FORMSPREE_ENDPOINT = 'https://formspree.io/f/mkgqakkd';
export const CLIENT_PORTAL_URL = 'https://portal.simpian.com/admin';
